import { AccountContext } from "views/AccountWrapper";

import useDetectMobile from "./useDetectMobile";
import useTypedContext from "./useTypedContext";
import useTypedFlags from "./useTypedFlags";

const useAssistantPanelAvailable = () => {
  const { aiChat } = useTypedFlags();
  const { viewer } = useTypedContext(AccountContext);
  const isAdmin = viewer.admin;
  const isMobile = useDetectMobile();

  return aiChat && isAdmin && !isMobile;
};

export default useAssistantPanelAvailable;